module.exports = __webpack_public_path__ + "img/trailer.a12b1359.jpg";